export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-stop-9abdb18b15e710c15af1c3995127c04f.svg";